import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'edit-vehicle-inventory-cost-crane',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="960" title="Costo de Grúa de Vehículo" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">   
        <div class="row">
          <div class="col-xs-4 col-sm-4 example-col">
            <div class="col-xs-12 col-sm-12 example-col">
                <images-scrollview [id]="f.id.value"></images-scrollview> 
            </div>                        
          </div>
          <div class="col-xs-8 col-sm-8 example-col">
            <div class="row">
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Folio de inventario:"></kendo-label>
                  <p class="data-info k-color-error right"><b>{{this.form.value.sku_inv}}</b></p>
              </div>    
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Folio de expediente:"></kendo-label>
                  <p class="data-info k-color-error right"><b>{{this.form.value.sku_exp}}</b></p>
              </div>  
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Autoridad:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.authority_abbreviation}} - {{this.form.value.authority_name}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Depósito:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.deposit_name}}</p>
              </div>         
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha de entrada:"></kendo-label>
                  <p class="data-info k-color-info">{{intl.formatDate(this.form.value.entry_date, "dd-MMM-yyyy")}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Marca:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.marck}}</p>
              </div>    
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Color:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.color}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Placas:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.plaque}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Número de serie:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.serie}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                <kendo-label text="Tipo de vehículo:"></kendo-label>
                <p class="data-info k-color-info">{{this.form.value.vehicle_type_name}}</p>                  
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                <kendo-label text="Costo de grúa:"></kendo-label>
                <kendo-textbox-container>
                  <kendo-numerictextbox formControlName="cost_crane" [format]="'c2'" [min]="0" [autoCorrect]="true" (valueChange)="numericValueChange($event)"></kendo-numerictextbox>
                </kendo-textbox-container> 
                <div *ngIf="f.cost_crane.invalid && (f.cost_crane.dirty || f.cost_crane.touched)">                  
                  <div *ngIf="f.cost_crane.errors">
                    <kendo-formerror *ngIf="f.cost_crane.errors.required">
                      Error: Campo requerido.
                    </kendo-formerror>
                  </div>   
                </div>
              </div>                
            </div>
          </div>          
        </div>             
      </div>
    </form> 

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }    
  `],
  providers: [ DatasourceService ]
})
export class EditVehicleInventoryCostCraneComponent extends CreateEditWindowComponent {

  @Input() table: string = 'vehicles_inventories';

  protected touched = false;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);
    
  }

  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Folio de expediente: '${dataItem.sku_exp}'`,
      `Marca: '${dataItem.marck}'`,
      `Color: '${dataItem.color}'`,
      `Placas: '${dataItem.plaque}'`
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.entry_date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0), 
      'authority_abbreviation': new FormControl((dataItem) ? dataItem.authority_abbreviation: ""),  
      'authority_name': new FormControl((dataItem) ? dataItem.authority_name: ""),  
      'sku_exp': new FormControl((dataItem) ? dataItem.sku_exp: ""),  
      'sku_inv': new FormControl((dataItem) ? dataItem.sku_inv: ""),  
      'vehicle_type_name': new FormControl((dataItem) ? dataItem.vehicle_type_name: ""),  
      'vehicle_type_fee': new FormControl((dataItem) ? dataItem.vehicle_type_fee: ""),  
      'deposit_name': new FormControl((dataItem) ? dataItem.deposit_name: ""),
      'marck': new FormControl((dataItem) ? dataItem.marck: ""),  
      'color': new FormControl((dataItem) ? dataItem.color: ""),  
      'plaque': new FormControl((dataItem) ? dataItem.plaque: ""),
      'serie': new FormControl((dataItem) ? dataItem.serie: ""),
      'entry_date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required),  
      // 'output_date': new FormControl(new Date(), Validators.required),
      'id_person': new FormControl(1, Validators.required), 
      // 'cost_crane': new FormControl((dataItem) ? dataItem.cost_crane: 0),
      'cost_crane': new FormControl(0),
      // // 'cost_pension': new FormControl(0, Validators.required),
      // 'cost_subtotal': new FormControl(0, Validators.required), 
      // 'cost_iva': new FormControl(0, Validators.required),
      // 'cost_total': new FormControl(0, Validators.required),
      // 'cost_paid': new FormControl(0, Validators.required),
      // 'cost_discount': new FormControl(0, Validators.required),
      // 'cost_discount_perc': new FormControl(0, Validators.required),
      // 'days': new FormControl(0)
    });    

  };

  // //@Override
  // protected getData(formGroup: FormGroup): Object {

  //   return Object.assign({}, formGroup.value, { 
  //     password: formGroup.value.pass1
  //   });

  // }; 

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem);    
  
  }  

  //@Override
  public delete(dataItem: any): void {
    
    this.mode = 'DELETE';
    this.opened = false;

    this.alertService.confirm(`<p>¿Esta seguro que desea eliminar el costo de grúa del sig. registro?</p> ${this.getObjectString(dataItem)}`, () => {

      this.onDelete(dataItem);

    });
    
  }

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, { 
      id: formGroup.value.id,
      cost_crane: (this.mode == 'EDIT') ? formGroup.value.cost_crane : null,
      id_vehicle_status: (this.mode == 'EDIT') ? 2 : 1,
    });

  };

  //@Override
  public onSave(): void {
    
    let data : any = this.getData(this.form);
    console.log('data', data)  
    
    // if (data.pass1 != data.pass2){
							
    //   this.alertService.showError('No coinciden las contraseñas.');
    //   return;
      
    // }
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  //@Override
  public onDelete(dataItem: any): void {
    
    let data : any = this.getData(this.form);

    data.id = dataItem.id;
    console.log('data', data)  
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          // this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );  

  }

}
